import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getMomentosPresupuestalesDelEgreso } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const MomentosPresupuestalesDelEgreso = ({ permission }) => (
  <PlainCRUD
    title="Momentos Presupuestales Del Egreso"
    permission={permission}
    get={getMomentosPresupuestalesDelEgreso}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
    readOnly
  />
);

export default MomentosPresupuestalesDelEgreso;
